import * as React from 'react';
import {RouteComponentProps, withRouter} from "react-router";
import CommonStreamItem, {StreamItemAction} from "../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import LeadEmailSentEvent from "../../../model/lead/event/LeadEmailSentEvent";
import JobEmailSentEvent from "../../../model/job/event/JobEmailSentEvent";
import EmailPreviewModal from "../../lead/email/EmailPreviewModal";

interface ComponentProps {
	/**
	 * Mail activity to display.
	 */
	activity: LeadEmailSentEvent | JobEmailSentEvent;
}

interface State {
	/**
	 * Indicates if email preview modal is visible.
	 */
	emailModalVisible: boolean
}

type Props = ComponentProps & RouteComponentProps<{}>;

class CommonActivityEmailItem extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {emailModalVisible: false};
	}

	render() {
		let actions: StreamItemAction[] = [];
		if (this.props.activity.data.message) {
			actions.push(StreamItemAction.new("Show message preview", () => this.setState({emailModalVisible: true})));
		}
		return (
			<React.Fragment>
				<CommonStreamItem event={this.props.activity} actions={actions}/>
				{this.state.emailModalVisible &&
				<EmailPreviewModal onClose={() => this.setState({emailModalVisible: false})} messageEvent={this.props.activity}/>}
			</React.Fragment>
		);
	}
}

export default withRouter<ComponentProps>(CommonActivityEmailItem)
